import { dev as keycloak } from './environment.keycloak';

const apiBase = "https://fleet.jbl-amr.com";

export const environment = {
  envName: 'jabil-robotics-dev',
  production: false,
  apis: [
    {
      apiName: 'core',
      apiBase: apiBase,
      apiPath: 'api/web/v1'
    },
    {
      apiName: 'insight',
      apiBase: apiBase,
      apiPath: 'api/insight/v1'
    },
    {
      apiName: 'inspect',
      apiBase: apiBase,
      apiPath: 'api/web/v1'
    }
  ],
  apiBase: apiBase,
  apiPath: 'api/insight/v1',
  ...keycloak
};
